import { render } from "./Pdfvuer.vue?vue&type=template&id=43f7df1d"
import script from "./Pdfvuer.vue?vue&type=script&lang=js"
export * from "./Pdfvuer.vue?vue&type=script&lang=js"

import "pdfjs-dist/web/pdf_viewer.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/lib/jenkins/jobs/ec2-frontend-global-production/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__